import { useState } from 'react';

import { ETPayButton } from '../../../../components/button';
import { ModalLinks } from '../../../../components/modal-links';
import { Spinner } from '../../../../components/spinner';
import { useFloatingAlert } from '../../../../hooks/useFloatingAlert';
import { useMerchant } from '../../../../hooks/useMerchant';
import { CustomLink } from '../../../../models/payment-links-custom';
import { PaymentLinksCustomServices } from '../../../../services/payment-links-custom';
import {
	ExportModalContent,
	ExportModalDescription,
	ExportModalTitle,
} from '../../components/table/styles';
import { ActionCard } from './components/actionCard';
import { ButtonContainer, WrapperContent } from './styles';
interface PauseLinkModalProps {
	show: boolean;
	onClose: () => void;
	data: CustomLink;
}

const PauseLinkModal = ({ show, onClose, data }: PauseLinkModalProps) => {
	const { merchantSelected } = useMerchant();
	const { handleShowAlert } = useFloatingAlert();

	const [loading, setLoading] = useState(false);
	const [errorMessage, setErrorMessage] = useState(''); // Agregamos el estado para el mensaje de error

	const handlePauseLink = async () => {
		try {
			setLoading(true);
			const response = await PaymentLinksCustomServices.PausePaymentLinkCustom({
				token: data.token,
				merchantCode: merchantSelected?.code || '',
			});
			if (response.code === 'OK') {
				handleShowAlert({
					type: 'success',
					message: 'El link de pago se ha pausado correctamente.',
				});
				onClose();
			} else {
				handleShowAlert({
					type: 'error',
					message: 'Ha ocurrido un error al pausar el link de pago.',
				});
				setErrorMessage(
					'Ha ocurrido un error al pausar el link de pago. Por favor, inténtalo de nuevo.',
				);
			}
		} catch (error) {
			handleShowAlert({
				type: 'error',
				message: 'Ha ocurrido un error al pausar el link de pago.',
			});
			setErrorMessage(
				'Ha ocurrido un error al pausar el link de pago. Por favor, inténtalo de nuevo.',
			);
		} finally {
			setLoading(false);
		}
	};

	const handleFinalizeLink = async () => {
		try {
			setLoading(true);
			const response = await PaymentLinksCustomServices.FinalizePaymentLinkCustom({
				token: data.token,
				merchantCode: merchantSelected?.code || '',
			});
			if (response.code === 'OK') {
				handleShowAlert({
					type: 'success',
					message: 'El link de pago se ha finalizado correctamente.',
				});
				onClose();
			} else {
				handleShowAlert({
					type: 'error',
					message: 'Ha ocurrido un error al finalizar el link de pago.',
				});
				setErrorMessage(
					response.message ||
						'Ha ocurrido un error al finalizar el link de pago. Por favor, inténtalo de nuevo.',
				);
			}
		} catch (error) {
			handleShowAlert({
				type: 'error',
				message: 'Ha ocurrido un error al finalizar el link de pago.',
			});
			setErrorMessage(
				'Ha ocurrido un error al finalizar el link de pago. Por favor, inténtalo de nuevo.',
			);
		} finally {
			setLoading(false);
		}
	};

	const renderContent = (): JSX.Element => {
		if (loading) {
			return <Spinner message="Pausando o Finalizando enlace de cobro..." />;
		} else if (errorMessage != '') {
			return (
				<ExportModalContent>
					<ExportModalTitle>Ha ocurrido un error</ExportModalTitle>
					<ExportModalDescription>{errorMessage}</ExportModalDescription>
					<ButtonContainer>
						<ETPayButton title="Cerrar" variant="effect" onClick={onClose} />
					</ButtonContainer>
				</ExportModalContent>
			);
		} else {
			return (
				<WrapperContent justFinish={data.sub_status != 'active'}>
					{data.sub_status === 'active' && (
						<ActionCard
							type="PAUSE"
							handlePauseLink={handlePauseLink}
							handleFinalizeLink={handleFinalizeLink}
						/>
					)}
					<ActionCard
						type="FINALIZED"
						handlePauseLink={handlePauseLink}
						handleFinalizeLink={handleFinalizeLink}
					/>
				</WrapperContent>
			);
		}
	};
	return (
		<ModalLinks
			show={show}
			onClose={onClose}
			title={loading ? '' : 'Cambiar estado de enlace de cobro'}
			type={data.sub_status != 'active' ? 'medium' : 'large'}
		>
			{renderContent()}
		</ModalLinks>
	);
};

export { PauseLinkModal };
